import ajax from '@/utils/ajax'

// 项目默认 baseURL 指向 /services/m1/；m1 下接口直接写相对路径，跨服务接口再用 ../ 切换。
const DISTRIBUTION_URL = 'distribution'
const DISTRIBUTOR_M2_URL = '../m2/distributor/manage'

// ==================== 实名认证 ====================
// 三个推广管理业务页面通过页面内门禁组件进行实名认证校验。
// 查看当前登录手机号是否已实名认证。
export const getRealNameAuthStatus = params => ajax.post(`${DISTRIBUTION_URL}/getVerifyStatus`, params)
// 提交姓名、身份证号、手机号并保存实名认证结果。
export const submitRealNameAuth = params => ajax.post(`${DISTRIBUTION_URL}/verify`, params)

// ==================== 通用下拉 ====================
// 查询“账号数据权限与临期站交集”的油站列表。
export const getPromotionGasList = params => ajax.get('gasInfo/getAboutExpireGasInfoList', { params })
// 查询推广管理可配置的油站列表。
export const getDistributorResourceList = () => ajax.post('gasInfo/getDistributorResourceList')
// 推广类型：1-新客加油推广、2-老客加油推广。
export const getPromotionTypeList = params => ajax.post(`${DISTRIBUTION_URL}/getPromotionTypeEnum`, params)
// 文档中该接口无入参，页面侧会按输入关键字做本地过滤。
export const searchPromoterList = params => ajax.post(`${DISTRIBUTION_URL}/queryPromotersByStations`, params)

// ==================== 订单推广明细 / 推广费分配明细 / 推广人统计 ====================
// 订单推广明细分页查询。
export const queryPromotionOrderList = params => ajax.post(`${DISTRIBUTION_URL}/orderPromotionDetail/queryList`, params)
// 订单推广明细导出，成功后到下载中心查看。
export const exportPromotionOrderList = params => ajax.post(`${DISTRIBUTION_URL}/orderPromotionDetail/export`, params)
// 推广费分配明细分页查询。
export const queryPromotionFeeDetailList = params => ajax.post(`${DISTRIBUTION_URL}/commissionDetail/queryList`, params)
// 推广费分配明细导出，成功后到下载中心查看。
export const exportPromotionFeeDetailList = params => ajax.post(`${DISTRIBUTION_URL}/commissionDetail/export`, params)
// 推广人统计分页查询。
export const queryPromoterStatsList = params => ajax.post(`${DISTRIBUTION_URL}/promoterStatistics/queryList`, params)
// 推广人统计导出，成功后到下载中心查看。
export const exportPromoterStatsList = params => ajax.post(`${DISTRIBUTION_URL}/promoterStatistics/export`, params)

// ==================== 推广人与推广费规则管理 ====================
// 按油站创建组织型推广者：创建老板账户前需要油站组织存在。
export const createStationOrgDistributor = params => ajax.post(`${DISTRIBUTOR_M2_URL}/createStationOrgDistributor`, params)
// 新建老板账户。
export const createBossAccount = params => ajax.post(`${DISTRIBUTOR_M2_URL}/createBossAccount`, params)
// 新建普通推广人账号。
export const createPromoter = params => ajax.post(`${DISTRIBUTOR_M2_URL}/createPersonAccount`, params)
// 更新推广人上级。
export const updatePromoterSuperior = params => ajax.post(`${DISTRIBUTOR_M2_URL}/updateParentDistributor`, params)
// 查询老板账户信息。
export const queryBossAccount = params => ajax.post(`${DISTRIBUTOR_M2_URL}/queryBossAccount`, params)
// 查询推广人管理列表。
export const queryPromoterManageList = params => ajax.post(`${DISTRIBUTOR_M2_URL}/queryPromoterList`, params)
// 查询可作为当前推广人上级的候选列表，后端已剔除本人及其下级。
export const queryUplineCandidates = params => ajax.post(`${DISTRIBUTOR_M2_URL}/listUplineCandidates`, params)
// 查询推广人推广费链路，用于推广费规则下的详细推广人比例预览。
export const queryPromoterFeeChainList = params => ajax.post(`${DISTRIBUTOR_M2_URL}/listPromoterFeeChain`, params)
// 查询个人推广二维码完整信息。
export const getPersonQr = params => ajax.post(`${DISTRIBUTOR_M2_URL}/getPersonQr`, params)
// 保存推广费规则。
export const savePromotionFeeRule = params => ajax.post(`${DISTRIBUTOR_M2_URL}/saveFeeRule`, params)
// 查询当前生效的推广费规则。
export const getPromotionFeeRuleDetail = params => ajax.post(`${DISTRIBUTOR_M2_URL}/getFeeRuleDetail`, params)
// 查询推广费规则历史记录。
export const queryPromotionFeeRuleRecordList = params => ajax.post(`${DISTRIBUTOR_M2_URL}/listFeeRuleRecords`, params)
// 根据模板生成二维码海报图。
export const generateImgByModel = params => ajax.post(`${DISTRIBUTOR_M2_URL}/generateImgByModel`, params)
// 同步商品实例ID到二维码。
export const syncOfferId = params => ajax.post(`${DISTRIBUTOR_M2_URL}/syncOfferId`, params)
// 查询推广设置三步进度。
export const getSetupProgress = params => ajax.post(`${DISTRIBUTOR_M2_URL}/getSetupProgress`, params)
// 根据推广者ID获取个人推广二维码图片URL。
export const getPersonQrUrl = params => ajax.post(`${DISTRIBUTOR_M2_URL}/getPersonQrUrl`, params)
// 根据油站ID获取油站推广二维码图片URL。
export const getStationQrUrl = params => ajax.post(`${DISTRIBUTOR_M2_URL}/getStationQrUrl`, params)
